
import { createContext } from "react";

import { TrialMetadata } from "@/apis/dtos";
import useGetTrialsMeta from "@/hooks/data/useGetTrialsMeta";

export interface ITrialsMetaContext extends Omit<ReturnType<typeof useGetTrialsMeta>, 'data' | 'total' | 'offset'> {
    data?: TrialMetadata[]
}

export const TrialsMetaContext = createContext<ITrialsMetaContext>({
    data: undefined,
    loading: false,
    validating: false,
    error: undefined,
    mutate: async () => { return undefined },
    refresh: async () => { return undefined }
});

export default TrialsMetaContext;